import React, { memo } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { colors } from 'theme/colors';
import { Flex } from '@chakra-ui/react';
import { percentsCharts } from './components/percentsCharts';

import * as Styles from './styles';

interface IValuesDashboard {
  finishedValue: number;
  inProgressValue: number;
  isLoading?: boolean;
}

const Chart: React.FC<IValuesDashboard> = ({ finishedValue, inProgressValue }) => {
  const colorsChart = [colors.brand.secondary, colors.brand.tertiary500];
  const colorsChartFinished = [colors.brand.secondary];
  const colorsChartInprogress = [colors.brand.tertiary500];

  const data = [
    { name: 'Finalizado', value: finishedValue },
    { name: 'Em andamento', value: inProgressValue },
  ];

  const onlyFinished = [{ name: 'Finalizado', value: finishedValue }];
  const onlyInProgress = [{ name: 'Em andamento', value: inProgressValue }];

  function deleteZeroDashboard() {
    if (finishedValue === 0) {
      return onlyInProgress;
    } else if (inProgressValue === 0) {
      return onlyFinished;
    } else {
      return data;
    }
  }

  function validationColorDashboard() {
    if (finishedValue === 0) {
      return colorsChartInprogress;
    } else if (inProgressValue === 0) {
      return colorsChartFinished;
    } else {
      return colorsChart;
    }
  }

  return (
    <>
      <ResponsiveContainer width="60%" height="100%">
        <PieChart width={400} height={400}>
          <Pie
            data={deleteZeroDashboard()}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={percentsCharts}
            outerRadius={100}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={validationColorDashboard()[index % colorsChart.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      <Flex flexDirection={'column'} width={'50%'} justifyContent="center">
        <Styles.BoxChakra width={'100%'}>
          <Styles.DotFineshed /> Finalizado ({finishedValue})
        </Styles.BoxChakra>
        <Styles.BoxChakra width={'100%'}>
          <Styles.DotInProgress /> Em andamento ({inProgressValue})
        </Styles.BoxChakra>
      </Flex>
    </>
  );
};

export const DashboardChart = memo(Chart);
